import { Tasa, TasaCrear, TasaEditar, TasaModal } from "../models/tasa";
import { crearTasa, editarTasa } from "../service/serviceTasas";



export function useTasas() {
    const save = async (data: TasaModal, dataediting: TasaEditar | undefined) => {
        let dataRequest: TasaCrear = {
            // id: data.id,
            tasa: data.valor,
            fechaInicioVigencia: data.fechaInicioVigencia,
            fechaTerminoVigencia: data.fechaTerminoVigencia,
            // activo: data.activo,
            montoDesde: data.montoDesde,
            montoHasta: data.montoHasta
        };

        if (dataediting) {
            dataRequest.id = dataediting.id;
            dataediting.tasa = dataRequest.tasa;
            dataediting.fechaInicioVigencia = dataRequest.fechaInicioVigencia;
            dataediting.fechaTerminoVigencia = dataRequest.fechaTerminoVigencia;
            dataediting.montoDesde = dataRequest.montoDesde;
            dataediting.montoHasta = dataRequest.montoHasta;      
            return await editarTasa(dataediting);            
        }

        return await crearTasa(dataRequest);
    }

    return {
        save
    }
}